module.exports = __webpack_public_path__ + "img/consultoria_4-3_1536.c328bfce.webp";